import React from 'react';
import { Switch } from '@/components/ui/switch';
import InlineEdit from '@/components/taxonomy/InlineEdit';
import FactorRow from '@/components/taxonomy/FactorRow';
import { AddFactorForm } from '@/components/taxonomy/AddForms';

const COLUMNS = [
  { key: 'positive_driver', title: 'Positive Drivers', dot: 'bg-[#2E9A6B]' },
  { key: 'gap', title: 'Gaps', dot: 'bg-[#C4353D]' },
];

export default function AttributeCard({ attr, canEdit, onUpdateAttr, onUpdateFactor, onAddFactor, index, inactiveNote = 'Inactive attributes and their factors are not used for AI or manual tagging.' }) {
  const id = attr.attribute_id;
  const active = attr.status === 'active';
  return (
    <section className={`tx-reveal bg-white border border-[#E2E8F0] rounded-2xl p-5 sm:p-6 ${active ? '' : 'bg-[#FAFBFC]'}`} style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }} data-testid={`attribute-card-${id}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <InlineEdit value={attr.name} canEdit={canEdit} onSave={(name) => onUpdateAttr(id, { name })} className="text-lg font-bold text-[#0F172A] font-['Montserrat']" testId={`attribute-name-${id}`} />
            {!active && <span className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] bg-[#F1F5F9] rounded-full px-2 py-0.5" data-testid={`attribute-inactive-${id}`}>Inactive</span>}
          </div>
          {attr.description && <p className="text-sm text-[#64748B] mt-0.5">{attr.description}</p>}
        </div>
        <label className="flex items-center gap-2 text-xs text-[#64748B] shrink-0">
          {active ? 'Active' : 'Inactive'}
          <Switch checked={active} disabled={!canEdit} onCheckedChange={(v) => onUpdateAttr(id, { status: v ? 'active' : 'inactive' })} data-testid={`attribute-status-${id}`} />
        </label>
      </div>
      {!active && <p className="text-xs text-[#94A3B8] mt-2">{inactiveNote}</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mt-5">
        {COLUMNS.map((c) => {
          const list = attr.factors.filter((f) => f.classification === c.key);
          const activeCount = list.filter((f) => f.status === 'active').length;
          return (
            <div key={c.key} data-testid={`attribute-${id}-${c.key}`}>
              <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-1 flex items-center gap-2"><span className={`w-2 h-2 rounded-full ${c.dot}`} />{c.title} · {activeCount}{list.length > activeCount ? <span className="normal-case tracking-normal font-medium text-[#94A3B8]">(+{list.length - activeCount} inactive)</span> : null}</p>
              {list.length ? list.map((f) => <FactorRow key={f.factor_id} factor={f} canEdit={canEdit} onUpdate={onUpdateFactor} />)
                : <p className="text-xs text-[#94A3B8] py-2.5">None yet.</p>}
            </div>
          );
        })}
      </div>
      {canEdit && <AddFactorForm attributeId={id} onAdd={onAddFactor} />}
    </section>
  );
}
